// File path: src/routes.js
import React from "react";
import { Route, Routes } from "react-router-dom"; // Importar Outlet
import PublicLayout from "./components/PublicLayout";

// Public Imports
import HomePage from "./pages/Public/HomePage";
import VerProductUni from "./pages/Public/ventaUnidad/VerProductosUni";
import ViewPedido from "./pages/Public/ventaUnidad/ViewPedido";
import NotFoundPage from "./pages/NotFoundPage";
import AboutUs from "./pages/Public/AboutUs";
import PreguntasFrecuentes from "./pages/Public/Questions";
import CategoriasUni from "./pages/Public/ventaUnidad/componenetes/categoriasUni";
import CatalogoAll from "./pages/Public/Catalogo";
import ContactUs from "./pages/Public/ContactUs";
import CategoriasSeccion from "./pages/Public/ventaUnidad/componenetes/categoriasSeccion";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index path="/:idSucursal?" element={<HomePage />} />
        <Route path="/:idSucursal?/Catalogo" element={<CatalogoAll />} />
        <Route path="/:idSucursal?/categorias" element={<CategoriasUni />} />
        <Route path="/:idSucursal?/Productos/:idCategoria" element={<VerProductUni />} />
        <Route path="/ViewOrder/:numPedido" element={<ViewPedido />} />
        <Route path="/:idSucursal?/SobreNosotros" element={<AboutUs />}/>
        <Route path="/:idSucursal?/PreguntaFrecuentes" element={<PreguntasFrecuentes />}/>
        <Route path="/:idSucursal?/Contacto" element={<ContactUs />}/>
        <Route path="/:idSucursal/:nombreSeccion" element={<CategoriasSeccion />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;